import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoneyWave = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6.703 10.174c4.43 1.21 8.864.082 13.297-1.048 4.833-1.232 9.667-2.464 14.5-.66.939.35 1.5 1.291 1.5 2.293v17.214c0 1.328-1.422 2.205-2.706 1.855-4.427-1.21-8.86-.083-13.294 1.045-4.883 1.233-9.717 2.466-14.502.66C4.558 31.184 4 30.246 4 29.24V12.03c0-1.33 1.423-2.205 2.703-1.855Zm13.247 15.16c2.506 0 4.494-2.39 4.494-5.383 0-2.945-1.988-5.334-4.494-5.334-2.406 0-4.444 2.39-4.444 5.334 0 2.994 2.038 5.383 4.444 5.383Z" })
});
export default SvgMoneyWave;
